/** No-op in production — was Cursor AI debug instrumentation, now safely removed. */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function agentDebugLog(_payload: {
  hypothesisId: string;
  location: string;
  message: string;
  data?: Record<string, unknown>;
}) {
  // intentionally empty
}
